export default __webpack_public_path__ + "static/media/userdocs.0a9abdb2.svg";